import {HistoryData} from './history-data';
import {AddressData} from './address-data';
import {ContactData} from './contact-data';
import {GeoPlace} from './geo-place-data';
import {ManagementData} from './management-data';
import {ContactNumberData} from './contact-number-data';
import {NoteData} from './note';

export interface PatientData {
  transmitterId: string;
  management: ManagementData;
  addressData: AddressData;
  geoPlace: GeoPlace;
  contactNumbers: Array<ContactNumberData>; // Eigene Nummern
  contacts: Array<ContactData>;
  transmitterHistory: Array<HistoryData>;
  history: Array<HistoryData>;
  notes: Array<NoteData>;
  alertGroups: Array<any>;
  type: string;
  _id?: string;
  _rev?: string;
}

export class PatientData implements PatientData {
    transmitterId = '';
    management: ManagementData = new ManagementData();
    addressData: AddressData = new AddressData();
    geoPlace: GeoPlace = new GeoPlace();
    contactNumbers: Array<ContactNumberData> = []; // Eigene Nummern
    contacts: Array<ContactData> = [];
    transmitterHistory: Array<HistoryData> = [];
    history: Array<HistoryData> = [];
    notes: Array<NoteData> = [];
    alertGroups: Array<any> = [];
    type = 'patient';
}
